<section class="pg4day">
    <h1 class="pg4day_title">{{ 'page4day.title' | transloco }}</h1>
    <p class="pg4day_subtitle">{{ 'page4day.subtitle' | transloco }}</p>
    <section class="pg4day_rain">
        <ul class="pg4day_rain_graph">
            <li>{{ 'page4day.tools.html5Css3' | transloco }}</li>
            <li>{{ 'page4day.tools.ibmCognos' | transloco }}</li>
            <li>{{ 'page4day.tools.jQuery' | transloco }}</li>
            <li>{{ 'page4day.tools.angular' | transloco }}</li>
            <li>{{ 'page4day.tools.d3js' | transloco }}</li>
            <li>{{ 'page4day.tools.photoshop' | transloco }}</li>
            <li>{{ 'page4day.tools.illustrator' | transloco }}</li>
        </ul>
        <img class="pg4day_rain_img" [attr.alt]="'alts.graphRain' | transloco" src="assets/img/amvara_web_graph_rain.png">
    </section>
    <img class="pg4day_cloud1" [attr.alt]="'alts.cloud1' | transloco" src="assets/img/amvara_web_graph_cloud1.svg">
    <img class="pg4day_cloud2" [attr.alt]="'alts.cloud2' | transloco" src="assets/img/amvara_web_graph_cloud2.svg"  >
    <img class="pg4day_cloud3" [attr.alt]="'alts.cloud3' | transloco" src="assets/img/amvara_web_graph_cloud1.svg">
    <img [routerLink]="language.link(['what-do-we-do'])" [attr.alt]="'alts.whatDoWeDo' | transloco" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="pg4day_imgsun" src="assets/img/amvara_web_icon_sun.svg">
    <img [attr.alt]="'common.goBack' | transloco" class="pg4day__back" [routerLink]="language.link(['about'])" src="assets/img/amvara_web_icon_(less).svg">
</section>
